import React, { useEffect, useState } from 'react';
import { Star, Quote, ChevronLeft, ChevronRight } from 'lucide-react';
import { testimonials } from '../data/mock';

const TestimonialsCarousel = () => {
  const [idx, setIdx] = useState(0);
  const [paused, setPaused] = useState(false);

  useEffect(() => {
    if (paused) return;
    const t = setInterval(() => setIdx((i) => (i + 1) % testimonials.length), 5500);
    return () => clearInterval(t);
  }, [paused]);

  const next = () => setIdx((i) => (i + 1) % testimonials.length);
  const prev = () => setIdx((i) => (i - 1 + testimonials.length) % testimonials.length);

  return (
    <section
      className="bg-[#5B3A24] text-[#F5EDDD] py-24 md:py-32 relative overflow-hidden"
      onMouseEnter={() => setPaused(true)}
      onMouseLeave={() => setPaused(false)}
    >
      {/* Big serif quote mark */}
      <Quote
        className="absolute top-12 left-12 h-32 w-32 text-[#7A5A3A]/40 hidden md:block"
        strokeWidth={0.8}
      />

      <div className="max-w-4xl mx-auto px-6 text-center relative z-10">
        <p className="text-[11px] tracking-[0.32em] uppercase text-[#E3D5B8] mb-8">
          — What people say
        </p>

        <div className="min-h-[260px] md:min-h-[300px] flex flex-col items-center justify-center">
          <div className="flex items-center justify-center gap-1 mb-7 text-[#E3D5B8]">
            {Array.from({ length: testimonials[idx].rating }).map((_, i) => (
              <Star key={i} className="h-4 w-4 fill-current" strokeWidth={1} />
            ))}
          </div>

          <p
            key={idx}
            className="text-2xl md:text-4xl leading-[1.25] text-[#F5EDDD] animate-[fadeIn_700ms_ease-out_both] max-w-3xl"
            style={{ fontFamily: "'Cormorant Garamond', serif" }}
          >
            “{testimonials[idx].quote}”
          </p>

          <div
            key={`meta-${idx}`}
            className="mt-9 animate-[fadeIn_700ms_ease-out_200ms_both]"
          >
            <p className="text-[13px] tracking-[0.22em] uppercase text-[#E3D5B8]">
              {testimonials[idx].author}
            </p>
            <p className="text-[11px] tracking-[0.22em] uppercase text-[#A07A4F] mt-1">
              {testimonials[idx].location} · {testimonials[idx].product}
            </p>
          </div>
        </div>

        {/* Controls */}
        <div className="mt-10 flex items-center justify-center gap-5">
          <button
            onClick={prev}
            aria-label="Previous review"
            className="p-2.5 border border-[#E3D5B8]/40 rounded-full hover:bg-[#F5EDDD] hover:text-[#5B3A24] transition-colors"
          >
            <ChevronLeft className="h-4 w-4" strokeWidth={1.5} />
          </button>
          <div className="flex items-center gap-1.5">
            {testimonials.map((_, i) => (
              <button
                key={i}
                onClick={() => setIdx(i)}
                aria-label={`Go to review ${i + 1}`}
                className={`h-1 rounded-full transition-all duration-500 ${
                  i === idx ? 'w-7 bg-[#F5EDDD]' : 'w-1.5 bg-[#F5EDDD]/40 hover:bg-[#F5EDDD]/70'
                }`}
              />
            ))}
          </div>
          <button
            onClick={next}
            aria-label="Next review"
            className="p-2.5 border border-[#E3D5B8]/40 rounded-full hover:bg-[#F5EDDD] hover:text-[#5B3A24] transition-colors"
          >
            <ChevronRight className="h-4 w-4" strokeWidth={1.5} />
          </button>
        </div>
      </div>
    </section>
  );
};

export default TestimonialsCarousel;
